import { Link } from 'react-router-dom';
import ApperIcon from '@/components/ApperIcon';
import { Button } from '@/components/ui/button';
import { DetailSkeleton } from '@/components/PageSkeleton';
import { Empty } from '@/components/ui/empty';
import { ErrorState } from '@/components/kit';

export function BackLink({ to, label }) {
  return (
    <Button variant="ghost" size="sm" asChild className="mb-4 -ml-2">
      <Link to={to}>
        <ApperIcon name="ArrowLeft" size={16} />
        {label}
      </Link>
    </Button>
  );
}

/** Loading, error and not-found states for a record view. Returns null once the record is ready. */
export function recordGate({ back, loading, record, error, run, what = 'Record' }) {
  let body = null;
  if (loading && record === undefined) {
    body = <DetailSkeleton />;
  } else if (error) {
    body = <ErrorState message={error} onRetry={run} />;
  } else if (!record) {
    body = (
      <Empty
        icon="Ghost"
        title={`${what} not found`}
        description="It may have been deleted, or it is not yours to see."
      />
    );
  }
  if (!body) return null;
  return (
    <div className="mx-auto max-w-5xl">
      {back}
      {body}
    </div>
  );
}
